import React from 'react';

const Field = ({ children }) => <div className="field">{children}</div>;

export default Field;
